export const LINK_PATH = {
  game: "/React-methods/game",
  home: "/React-methods/",
  methods: "/React-methods/methods",
  counter: "/React-methods/counter",
  login: '/React-methods/login',
};
